import { set } from '@/utils/vuex'

export default {
  SET_DISPOSITIVOS: set('dispositivos'),
  SET_SENSORES: set('sensores'),
}
